//tslint:disable
export const extractDomProps = (props: any, additionalPropsNamesThatAreNotDomProps?: string[]) => {
   //https://reactjs.org/warnings/unknown-prop.html
   //list of problem props below - other solution is to specify all 100s of allowed dom props and return those
   const {
      align,
      alignItems,
      alignContent,
      avatarId,
      avatarInitials,
      avatarUrl,
      border,
      bottomDecorator,
      bottomLeftDecorator,
      bottomRightDecorator,
      code,
      disableLabelWordWrap,
      flexDirection,
      flexWrap,
      fill,
      formButtonType,
      gap,
      hgap,
      horizontalFill,
      horizontalAlign,
      inline,
      justifyContent,
      keyboard,
      leftDecorator,
      mark,
      maxWidth,
      maxHeight,
      minWidth,
      minHeight,
      maxLabelWidth,
      nowrap,
      padding,
      paddingLeft,
      paddingRight,
      paddingTop,
      paddingBottom,
      prefixOverride,
      rightDecorator,
      scroll,
      stretchChildren,
      strikethrough,
      strong,
      testId,
      topDecorator,
      topLeftDecorator,
      topRightDecorator,
      underline,
      verticalAlign,
      verticalFill,
      vgap,
      ...domProps
   } = props;

   additionalPropsNamesThatAreNotDomProps?.forEach((value) => {
      delete domProps[value];
   });

   return domProps;
};
